
import { i18nText } from '@/locales';
import {ProductsEntity, StoreOperation} from "@/entity/warehouse/Operations/OperationsMove";
import { ProductsStockMix } from "@/UI/mixins/Store/ProductsStockMix";
import moment from 'moment';

export class OperationMoveProductData implements StoreOperation {
    store_from: number | null ;
    store_to: number | null;
    salon_id: number | null;
    date: string;
    time: string;
    products: (ProductsEntity)[] | null;
    constructor() {
        this.store_from = null;
        this.store_to = null;
        this.salon_id = 0;
        this.date = moment(new Date(), 'DD.MM.YYYY') as any;
        this.time = moment(new Date(), 'HH:mm') as any;
        this.products = [];
    }
    deleteProduct(index: number): void {
        if (this.products) this.products.splice(index, 1);
    }
    addProduct(product:ProductsEntity): void {
        if (this.products)
            this.products.push(product)
    }
}
export class ProductData implements ProductsEntity {
    id: number;
    quantity: number;
    constructor() {
        this.id = 0
        this.quantity = 1
    }
}
const requiredProducts = (field: unknown, value: (ProductsEntity)[] | null): boolean => {
    if (value && value.length > 0) {
        return true;
    }
    return false;
};
const checkProducts = (field: unknown, value: (ProductsEntity)[] | null): boolean => {
    if (value && value.length > 0) {
        for (const product of value) {
            if (product.id === 0) {
                return false;
            }
        }
        return true;
    }
    return false;
};

export const FormRules = {
    store_from: [{ required: true, message: i18nText("Укажите с какого склада будет перемещаться товар") }],
    store_to: [{ required: true, message: i18nText("Укажите на какой склад будет перемещен товар") }],
    date: [{ required: true, message: i18nText("Укажите дату")}],
    time: [{ required: true, message: i18nText("Укажите время")  }],
    products: [{ validator: requiredProducts, message: i18nText("Укажите товары"), trigger: "change" }, { validator: checkProducts, message: i18nText("Выберите товары из списка"), trigger: "change" }],
};
